// extracted by mini-css-extract-plugin
module.exports = {"success":"styles_success__ry9rH","title":"styles_title__1EMF1","p":"styles_p__-BuwF","cardBody":"styles_cardBody__14pww"};